export const PROVIDE_PHONE_NUMBER_MODAL = 'providePhoneNumberModal'
